import CrudRequest from '@rootCommon/services/crud-request';
import { HEALTHCHECK, INFO } from '@rootCommon/constants/end-points';
import { HealthcheckInfo } from '@rootTypes/healthcheck';

class HealthcheckService {
  private getHealthcheck = async (pathname: string): Promise<HealthcheckInfo> => {
    const res = await CrudRequest.get<HealthcheckInfo>(`${HEALTHCHECK}/${pathname}`);

    return res.data;
  };

  getHealthcheckInfo = () => this.getHealthcheck(INFO);
}

export default new HealthcheckService();
